import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import PicUpload from "@/components/picUpload/index.vue";
let onlineBooking = class onlineBooking extends Vue {
  constructor() {
    super(...arguments);
    this.postForm = {
      title: "",
      required: "1",
      jsonConfig: {
        showIndex: true
      }
    };
    this.rules = {
      title: [{
        required: true,
        message: "请输入标题",
        trigger: "blur"
      }],
      required: [{
        required: true,
        message: "请选择是否必填",
        trigger: "blur"
      }],
      "jsonConfig.appointmentName": [{
        required: true,
        message: "请输入预约事项名称",
        trigger: "blur"
      }],
      "jsonConfig.imgUrl": [{
        required: true,
        message: "请上传图片",
        trigger: "change"
      }],
      "jsonConfig.weeklyAppointmentDate": [{
        required: true,
        message: "请选择每周可约日期",
        trigger: "change"
      }],
      "jsonConfig.dailyStartAndEndTime": [{
        required: true,
        message: "请选择每日起止时间",
        trigger: "change"
      }],
      "jsonConfig.hourlyDuration": [{
        required: true,
        message: "请输入每时段持续时间",
        trigger: "blur"
      }, {
        validator: this.validateHourlyDuration,
        trigger: "blur"
      }],
      "jsonConfig.intervalTime": [{
        required: true,
        message: "请输入间隔时间",
        trigger: "blur"
      }, {
        validator: this.validateHourlyDuration,
        trigger: "blur"
      }],
      "jsonConfig.appointmentDateRange": [{
        required: true,
        message: "请选择限制截止日期",
        trigger: "change"
      }]
    };
    this.weeklyOptions = [{
      label: "周一",
      value: "MONDAY"
    }, {
      label: "周二",
      value: "TUESDAY"
    }, {
      label: "周三",
      value: "WEDNESDAY"
    }, {
      label: "周四",
      value: "THURSDAY"
    }, {
      label: "周五",
      value: "FRIDAY"
    }, {
      label: "周六",
      value: "SATURDAY"
    }, {
      label: "周日",
      value: "SUNDAY"
    }];
  }
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  validateHourlyDuration(rule, value, callback) {
    if (value % 5 > 0) {
      callback(new Error("请设置为5的倍数！"));
    } else {
      callback();
    }
  }
  get dateRangePickerOptions() {
    const _than = this;
    const dateRangePickerOptions = {
      disabledDate(time) {
        if (_than.postForm.jsonConfig.appointmentDateRange.length > 0) return new Date(_than.postForm.jsonConfig.appointmentDateRange[0]).getTime() - 24 * 60 * 60 * 1000 > time.getTime() || new Date(_than.postForm.jsonConfig.appointmentDateRange[1]).getTime() < time.getTime();
        return false;
      }
    };
    return dateRangePickerOptions;
  }
  get quotaLabel() {
    return this.postForm.jsonConfig.appointmentMethod === "APPOINTMENT_METHOD_PERIOD" ? "每时段名额" : "每日名额";
  }
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  addDateRange() {
    this.postForm.jsonConfig.notAppointmentDateRange.push([]);
  }
  deleteDateRange(index) {
    this.postForm.jsonConfig.notAppointmentDateRange.splice(index, 1);
  }
  getFormInstance() {
    return this.$refs.postForm;
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }
  async validate() {
    return await this.getFormInstance().validate().catch(err => {
      return err;
    });
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
};
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], onlineBooking.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], onlineBooking.prototype, "disabled", void 0);
__decorate([Watch("value", {
  deep: true,
  immediate: true
})], onlineBooking.prototype, "watchPropData", null);
__decorate([Watch("postForm", {
  deep: true
})], onlineBooking.prototype, "watchPostForm", null);
onlineBooking = __decorate([Component({
  name: "onlineBooking",
  components: {
    questionSettingTemplate,
    PicUpload
  }
})], onlineBooking);
export default onlineBooking;